import { Icon } from '@components';
import processosWeb from './ProcessosWeb';

export default [
  {
    path: '/analise-desempenho',
    icon: Icon.FieldTimeOutlined,
    text: 'Análise de Desempenho',
    match: /\/analise-desempenho+$/,
    exact: true,
    sider: true,
  },
  ...processosWeb,
];
